import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { DataStore } from "@aws-amplify/datastore";
import { VehicleModelGeneralInfo } from "./models";
import "./App.css";

async function fetchVehicles() {
  try {
    const vehicles = await DataStore.query(VehicleModelGeneralInfo);
    // console.log(vehicles);
    return vehicles.map((vehicle) => vehicle.Picture);
  } catch (error) {
    console.error("Error fetching vehicles:", error);
    return [];
  }
}

const CarouselHomepage = () => {
  const [vehicleImages, setVehicleImages] = useState([]);
  const [leftMostSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    async function fetchVehicleImages() {
      const images = await fetchVehicles();
      // console.log(images);
      setVehicleImages(images);
    }

    fetchVehicleImages();
  }, []);

  const handleBeforeChange = (oldIndex, newIndex) => {
    // console.log("newIndex: ", newIndex);
    setCurrentSlide(newIndex);
  };

  useEffect(() => {
    // console.log(`Current center image index: ${leftMostSlide}`);
    // console.log(`Image URL: ${vehicleImages[leftMostSlide]}`);
  }, [leftMostSlide, vehicleImages]);

  const settings = {
    // Your carousel settings here
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: true,
    autoplaySpeed: 2000,
    autoplay: true,
    beforeChange: handleBeforeChange,
  };

  return (
    <div className="carousel-container">
      <Slider {...settings} beforeChange={handleBeforeChange}>
        {vehicleImages.map((image, index) => (
          <div
            key={index}
            className={`carousel-item ${index === leftMostSlide
              ? "side"
              : (index === 0 && leftMostSlide === vehicleImages.length - 1) || index === leftMostSlide - 1 || index === leftMostSlide + 1
                ? "largest"
                : "side"
              }`}
          >
            <div className="image-container">
              <img
                src={image}
                alt={`Vehicle ${index}`}
                className="carousel-image"
              />
              {/* <p className="image-caption">Vehicle {index}</p> */}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CarouselHomepage;
